import React from 'react';
import { Typography, InputField, Box } from 'vindi-ds-components';

function ProductInvoice() {
  return (
    <Box marginBottom='2em'>
      <Typography variant='subtitle2' component='h3'>Nota fiscal</Typography>
      <InputField checkbox checked value='true' name='invoice' label='Incluir produto na emissão de Notas Fiscais' />
      <Box width='23.6em'>
        <InputField
          label='Observação (Opcional)'
          name='description'
          placeholder='Observação'
        />
      </Box>
    </Box>
  );
}

export default ProductInvoice;
